'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _UrlWatcher = require('@bd/bdcore-data/build/UrlWatcher');

var _UrlWatcher2 = _interopRequireDefault(_UrlWatcher);

var _NoRouteWrapper = require('@bd/bdcore-data/build/NoRouteWrapper');

var _NoRouteWrapper2 = _interopRequireDefault(_NoRouteWrapper);

var _AbstractStack2 = require('../AbstractStack');

var _AbstractStack3 = _interopRequireDefault(_AbstractStack2);

var _DefaultPageComponents = require('../DefaultPageComponents');

var _DefaultPageComponents2 = _interopRequireDefault(_DefaultPageComponents);

var _ScrollToHash = require('../ScrollToHash');

var _ScrollToHash2 = _interopRequireDefault(_ScrollToHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleCommunity = function (_AbstractStack) {
  (0, _inherits3.default)(SingleCommunity, _AbstractStack);

  function SingleCommunity(props) {
    (0, _classCallCheck3.default)(this, SingleCommunity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SingleCommunity.__proto__ || (0, _getPrototypeOf2.default)(SingleCommunity)).call(this, props));

    _this.defaultComponents = _DefaultPageComponents2.default;
    return _this;
  }

  (0, _createClass3.default)(SingleCommunity, [{
    key: 'render',
    value: function render() {
      var _getRawComponents = this.getRawComponents(),
          Root = _getRawComponents.Root,
          components = (0, _objectWithoutProperties3.default)(_getRawComponents, ['Root']);

      var routes = this.getExtendedRoutes();

      return _react2.default.createElement(
        Root,
        null,
        _react2.default.createElement(
          _bdcoreNamedRoutes.Switch,
          null,
          routes.map(function (props) {
            return _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({
              key: props.name
            }, props, {
              component: (0, _UrlWatcher2.default)(props.component)
            }));
          }),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'index', exact: true, path: '/', render: (0, _UrlWatcher2.default)(components.Index) }, this.getComponentProps(components.Index))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'homes', exact: true, path: '/homes', render: (0, _UrlWatcher2.default)(components.HomesList) }, this.getComponentProps(components.HomesList))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'home-detail', exact: true, path: '/homes/:homeStreetAddress', render: (0, _UrlWatcher2.default)(components.HomeDetail) }, this.getComponentProps(components.HomeDetail))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'plans', exact: true, path: '/plans', render: (0, _UrlWatcher2.default)(components.PlansList) }, this.getComponentProps(components.PlansList))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'plan-detail', exact: true, path: '/plans/:planName', render: (0, _UrlWatcher2.default)(components.PlanDetail) }, this.getComponentProps(components.PlanDetail))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'blog', exact: true, path: '/blog', render: (0, _UrlWatcher2.default)(components.BlogpostList) }, this.getComponentProps(components.BlogpostList))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'blog-category', exact: true, path: '/blog/category-:blogCategory', render: (0, _UrlWatcher2.default)(components.BlogpostList) }, this.getComponentProps(components.BlogpostList))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'blog-tag', exact: true, path: '/blog/tag-:blogTag', render: (0, _UrlWatcher2.default)(components.BlogpostList) }, this.getComponentProps(components.BlogpostList))),
          _react2.default.createElement(_reactRouterDom.Route, (0, _assign2.default)({ name: 'blogpost-detail', exact: true, path: '/blog/:blogpostTitle', render: (0, _UrlWatcher2.default)(components.BlogpostDetail) }, this.getComponentProps(components.BlogpostDetail))),
          _react2.default.createElement(_reactRouterDom.Route, { exact: true, render: (0, _UrlWatcher2.default)((0, _NoRouteWrapper2.default)(components.NoRoute)) })
        ),
        _react2.default.createElement(_ScrollToHash2.default, null)
      );
    }
  }]);
  return SingleCommunity;
}(_AbstractStack3.default);

SingleCommunity.propTypes = (0, _extends3.default)({}, _AbstractStack3.default.propTypes, {
  store: _propTypes2.default.object
});

SingleCommunity.defaultProps = (0, _extends3.default)({}, _AbstractStack3.default.defaultProps, {
  store: undefined
});

exports.default = SingleCommunity;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-navigation-stacks/build/Stacks/SingleCommunity.js
// module id = 968
// module chunks = 0